<script>
export default {
  data() {
    return {
      selectedRole: '',
    };
  },

  mounted() {
    this.setSelectedRole();
  },

  methods: {
    changeRole() {
      location.href = location.pathname + '?role=' + this.selectedRole;
    },

    setSelectedRole() {
      let query = location.search.substring(1).split('=');

      if (query && typeof query === 'object' && query[1]) {
        this.selectedRole = query[1];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  h1 {
    width: 15%;
    display: inline-block;
  }

  .admin-page-title {
    > .select-wrapper {
      width: 13%;
      display: inline-block;
      top: -10px;
    }
  }
</style>
